/**
 * Servicio del Asistente IA — puerto de `IbuFront/src/services/asistenteIAApi.js`
 * (V1) al patrón de IbuFront2: usa la instancia única `apiClient` (baseURL +
 * interceptores ya resuelven Authorization/401/errores) en vez de axios directo con
 * env var propia. Endpoints confirmados en
 * `IbuBack2/src/api/v1/modules/asistente-ia/asistente-ia.routes.js`:
 *   POST   /asistente-ia/ask                     body: { mensaje, id_conversacion }
 *   GET    /asistente-ia/conversaciones
 *   GET    /asistente-ia/conversaciones/:id
 *   DELETE /asistente-ia/conversaciones/:id
 * Todos gateados por `requirePermission('asistente-ia:usar')` — ver
 * `hasPermiso('asistente-ia:usar')` en el frontend antes de llamar cualquiera de estos.
 *
 * Nota de forma de respuesta (ver `chat.service.js#chat`): `ask` regresa
 * `{ id_conversacion, titulo, text, chart, charts, rawData }` — `chart` es solo la
 * PRIMERA gráfica del turno (compat V1), `charts` es el arreglo completo (puede haber
 * más de una si el modelo llamó `generate_chart` varias veces). El frontend usa
 * `charts` cuando existe y cae a `chart` si no (conversaciones viejas).
 */
import apiClient from './apiClient.js';

const asistenteIA = {
  preguntar: (mensaje, idConversacion) =>
    apiClient.post('/asistente-ia/ask', { mensaje, id_conversacion: idConversacion || null }).then((r) => r.data),

  listarConversaciones: () =>
    apiClient.get('/asistente-ia/conversaciones').then((r) => r.data),

  obtenerConversacion: (id) =>
    apiClient.get(`/asistente-ia/conversaciones/${id}`).then((r) => r.data),

  eliminarConversacion: (id) =>
    apiClient.delete(`/asistente-ia/conversaciones/${id}`).then((r) => r.data),
};

export default asistenteIA;
